import { CSSObject, Stack, Typography, styled } from '@mui/material';

export const StyledSliderWrapper = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(4),
  width: '100%',
}));

export const StyledStage = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '100%',
  height: 480,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  [theme.breakpoints.down(800)]: {
    height: 440,
  },
}));

export const StyledCard = styled(Stack)(({ theme }) => ({
  position: 'absolute',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  width: 'min(300px, 84vw)',
  height: 420,
  overflow: 'hidden',
  background: theme.palette.greyBackgroundColor?.INVERTED,
  border: `1px solid ${theme.palette.invertedBorder?.LIGHT}`,
  borderRadius: theme.spacing(3),
  padding: theme.spacing(4),
  transition: 'transform 0.4s ease, opacity 0.4s ease, filter 0.4s ease',

  '&.center': {
    transform: 'translateX(0) scale(1) rotate(0deg)',
    opacity: 1,
    zIndex: 3,
    border: `1px solid ${theme.palette.cyanColors?._0}59`,
    boxShadow: `0px 0px 60px 0px ${theme.palette.cyanColors?._0}26, inset 0px 1px 0px 0px rgba(255, 255, 255, 0.06)`,
  },
  '&.left': {
    transform: 'translateX(-250px) scale(0.88) rotate(-4deg)',
    opacity: 0.6,
    zIndex: 2,
    cursor: 'pointer',
  },
  '&.right': {
    transform: 'translateX(250px) scale(0.88) rotate(4deg)',
    opacity: 0.6,
    zIndex: 2,
    cursor: 'pointer',
  },
  '&.farLeft': {
    transform: 'translateX(-460px) scale(0.78) rotate(-6deg)',
    opacity: 0.35,
    filter: 'blur(1px)',
    zIndex: 1,
    cursor: 'pointer',
  },
  '&.farRight': {
    transform: 'translateX(460px) scale(0.78) rotate(6deg)',
    opacity: 0.35,
    filter: 'blur(1px)',
    zIndex: 1,
    cursor: 'pointer',
  },

  [theme.breakpoints.down(1280)]: {
    '&.farLeft, &.farRight': {
      display: 'none',
    },
    '&.left': {
      transform: 'translateX(-200px) scale(0.85) rotate(-4deg)',
    },
    '&.right': {
      transform: 'translateX(200px) scale(0.85) rotate(4deg)',
    },
  },
  [theme.breakpoints.down(800)]: {
    '&.left, &.right': {
      display: 'none',
    },
    height: 400,
    padding: theme.spacing(3),
  },
}));

export const StyledQuoteGroup = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

export const StyledQuote = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  fontSize: '36px !important',
  lineHeight: '1 !important',
}));

export const StyledText = styled(Typography)(({ theme }) => ({
  color: theme.palette.invertedContent?.PRIMARY,
  fontFamily: 'Satoshi',
  fontWeight: 400,
  fontSize: '15px !important',
  lineHeight: '1.5 !important',
  display: '-webkit-box',
  WebkitLineClamp: 9,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
}));

export const StyledFooterStack = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(2),
  marginTop: 'auto',
}));

export const StyledCaptionStack = styled(Stack)(() => ({
  gap: 0,
}));

export const StyledName = styled(Typography)(({ theme }) => ({
  color: theme.palette.invertedContent?.PRIMARY,
  fontFamily: 'ClashDisplay',
  fontSize: '16px !important',
  lineHeight: '22px !important',
}));

export const StyledPosition = styled(Typography)(({ theme }) => ({
  color: theme.palette.invertedContent?.SECONDARY,
  fontFamily: 'ClashDisplay',
  fontSize: '12px !important',
  lineHeight: '18px !important',
}));

export const StyledAvatar = styled('img')(({ theme }) => ({
  width: 57,
  height: 57,
  borderRadius: '50%',
  objectFit: 'cover',
  flexShrink: 0,
  border: `1px solid ${theme.palette.cyanColors?._0}59`,
  boxShadow: `0px 0px 20px 0px ${theme.palette.cyanColors?._0}66`,
}));

export const StyledNavRow = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(2),
}));

export const StyledDots = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(0.75),
}));

export const StyledDot = styled('button')<{ active: boolean }>(
  ({ theme, active }) => ({
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    height: 6,
    width: active ? 18 : 6,
    borderRadius: 3,
    background: active
      ? theme.palette.cyanColors?._0
      : theme.palette.invertedBorder?.MEDIUM,
    transition: 'width 0.2s ease, background 0.2s ease',
  })
);
